import { useAuthContext } from '@r-and-a-shared-ui/auth-client';
import { useCallback, useEffect, useState } from 'react';
import { useGenericActionContext } from '../../contexts';
import { VODPlaylistInput, VODPlaylistQuery } from '@r-and-a-shared-ui/endeavor-library';

export const usePlaylist = (props: { playlistId: string }) => {
  const {
    userState: { isAuthenticated, refreshToken, accessToken, idToken },
  } = useAuthContext();
  const { VIDEO_API } = useGenericActionContext();
  const [playlist, setPlaylist] = useState<any>(null);

  const fetchPlaylist = useCallback(async (input: VODPlaylistInput) => {
    try {const data = await VODPlaylistQuery({ input });
      setPlaylist(data);
    } catch(error) {
      console.error('Error fetching playlist', error);
    }
  },[]);

  useEffect(() => {
    if(!VIDEO_API.ENDEAVOR_CONFIG) {
      return;
    }

    const { url, xApiKey, realm } = VIDEO_API.ENDEAVOR_CONFIG;
    if(!props.playlistId || !url || !realm || !xApiKey || isAuthenticated === null) {
      return;
    }

    const input = {
      isAuthenticated,
      playlistId: props.playlistId,
      refreshToken,
      accessToken,
      idToken,
      config: VIDEO_API.ENDEAVOR_CONFIG
    };
    fetchPlaylist(input);
  }, [VIDEO_API.ENDEAVOR_CONFIG,
    accessToken,
    fetchPlaylist,
    idToken,
    isAuthenticated,
    props.playlistId,
    refreshToken]);
  return { playlist };
};
